/* Life Is Golden — Scroll Reveal & Interactions */
(function () {
  'use strict';

  // Intersection Observer for scroll reveal animations
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('.lig-reveal');
    if (!revealElements.length) return;

    // Mark body as ready so CSS knows to apply initial hidden state
    document.body.classList.add('lig-reveal-ready');

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px',
      }
    );

    revealElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Hero parallax-like fade on scroll
  function initHeroScrollFade() {
    var hero = document.querySelector('.lig-hero');
    if (!hero) return;

    var content = hero.querySelector('.lig-hero__content');
    var media = hero.querySelector('.lig-hero__media img');
    if (!content || !media) return;

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.scrollY;
          var heroHeight = hero.offsetHeight;

          if (scrollY < heroHeight) {
            var progress = scrollY / heroHeight;
            var contentOpacity = 1 - progress * 1.5;
            var mediaScale = 1 + progress * 0.1;

            content.style.opacity = Math.max(0, contentOpacity);
            content.style.transform = 'translateY(' + (scrollY * 0.3) + 'px)';
            media.style.transform = 'scale(' + mediaScale + ')';
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollReveal();
      initHeroScrollFade();
    });
  } else {
    initScrollReveal();
    initHeroScrollFade();
  }

  // Re-initialize on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initHeroScrollFade();
  });
})();
